import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuShortCutService {
  private eventToChildSource = new Subject<any>();
  eventToChild$ = this.eventToChildSource.asObservable();

  emitEventToChild(data: any) {
    this.eventToChildSource.next(data);
  }
}
